import { EditFormBase } from '../../core/helper/editFormBase';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MessageDialog } from '../../components/message-dialog/messageDialog';
import { Location } from '@angular/common';
import { ConfiguracionEmpresaService } from '../../core/services/configuracionEmpresa.service';
import { ConfiguracionEmpresa } from '../../core/models/configuracionEmpresa.model';
//import { EnumConceptType } from '../../core/Enums/EConceptType.enum';
import { SessionHelper } from '../../core/helper/sessionHelper';
import { A3LCompanyService } from '../../core/services/a3LCompany.service';
//import { A3LCompanyPayConcepts } from '../../core/models/a3LCompanyPayConcepts.model';
import { A3LCompanyAgreements } from '../../core/models/a3LCompanyAgreements.model';
import { ProvinciaService } from '../../core/services/provincias.service';
import { Provincia } from '../../core/models/provincia.model';
import { ConveniosEmpresa } from '../../core/models/conveniosEmpresa.model';
import { ConveniosEmpresaService } from '../../core/services/conveniosEmpresa.service';
import { ConveniosListComponent } from '../..//hostelHR/convenios/convenios-list/convenios-list.component';
import { DatosCalculoBolsaVacaciones } from '../../core/models/datosCalculo.model';
import { ActivatedRoute, Router } from '@angular/router';
import { A3LCompany } from '../../core/models/a3LCompany.model';
import { EnumConceptType } from '../../core/Enums/EConceptType.enum';
import { User } from '../../core/models/user.model';
import { UserService } from '../../core/services/user.service';
import { DatoCalculoService } from '../../core/services/datosCalculo.service';
import { NotificacionesEmpresa } from '../../core/models/notificacionesEmpresas.model';
import { ETipoNotificacion } from '../../core/Enums/ETipoNotificacion.enum';
import { DxPopupComponent } from 'devextreme-angular';

@Component({
  selector: 'app-my-companies-config-detail',
  templateUrl: './my-companies-config-detail.component.html',
  styleUrls: ['./my-companies-config-detail.component.scss'],
  providers: [ConfiguracionEmpresaService, A3LCompanyService, ProvinciaService, ConveniosEmpresaService, UserService, DatoCalculoService]
})
export class MyCompaniesConfigDetailComponent extends EditFormBase<ConfiguracionEmpresa, string> implements OnInit {

  // Propiedades del panel contenedor
  panelIcon = 'cog'; // Material icon
  panelTitle = 'Configuración empresa';
  panelDescription = '';

  selectedAgreements: string[];

  companySelectedAgreementValue: string;
  companySelectedAgreements: ConveniosEmpresa[];
  companySelectedAgreement: ConveniosEmpresa;
  users: User[] = new Array<User>();
  selectedUsers: string[];

  agreements: A3LCompanyAgreements[] = new Array<A3LCompanyAgreements>();
  provincias: Provincia[] = new Array<Provincia>();

  @ViewChild(ConveniosListComponent)
  calculosConvenios: ConveniosListComponent;

  calculosBolsaVacacionesActivo: boolean;
  loadingFilterData: boolean;

  constructor(
    _route: ActivatedRoute,
    _modelService: ConfiguracionEmpresaService,
    _messageDialog: MessageDialog,
    protected _sessionHelper: SessionHelper,
    protected companyService: A3LCompanyService,
    protected _provinciasService: ProvinciaService,
    protected _usersService: UserService,
    protected _datosCalculoService: DatoCalculoService,
    protected _conveniosEmpresaService: ConveniosEmpresaService,
    _router: Router,
    _location: Location
  ) {
    super(_modelService, _messageDialog, _route, _router, _location, ConfiguracionEmpresa);
    this.getModel();
  }

  ngOnInit() {
    this.getProvincias();
    this.getUsers();
  }

  afterModelLoad(): void {
    if (this.model.Convenios)
      {
        this.selectedAgreements = this.model.Convenios.map(x => `${x.Codigo}¬${x.Revision}`);
        console.log(this.selectedAgreements);
      }


    if (this.model.Notificaciones)
      this.selectedUsers = this.model.Notificaciones.map(x => x.IdUsuario);

    if (!this.model.isNew)
      this.getSelectedAgreements();
  }

  afterModelUpdated(success: boolean): void {
    this.getSelectedAgreements();
    if (!success) {
      this.getModel();
    }
  }

  afterModelCreated(success: boolean): void {
    if (!success)
      return;
  }

  getModelInstance(): ConfiguracionEmpresa {
    return new ConfiguracionEmpresa();
  }

  update() {
    this.processAgreements();
    this.processNotifications();
    super.update();
  }

  create() {
    this.processAgreements();
    this.processNotifications();
    this.model.IdCliente = this._sessionHelper.User.IdCliente;
    super.create();
  }

  processAgreements() {
    let parentId = this.model.isNew ? null : this.model.Id.toString();

    if (!this.model.Convenios)
      this.model.Convenios = new Array<ConveniosEmpresa>();

    this.model.Convenios = this.model.Convenios.filter(x => this.selectedAgreements.includes(`${x.Codigo}¬${x.Revision}`));

    this.selectedAgreements.forEach(id => {

      const valoresConvenio: string[] = id.split("¬")
      console.log(valoresConvenio)
      if (this.model.Convenios.findIndex(x => x.Codigo == valoresConvenio[0]) == -1) {

        //const agreement = this.agreements.find(x => x.agreementCode === valoresConvenio[0]);

        const agreement = this.agreements.find(x => x.agreementCode === valoresConvenio[0] && x.revision === Number(valoresConvenio[1]))
        if (agreement) {
          const convenio: ConveniosEmpresa = {

            Codigo: valoresConvenio[0],
            Descripcion: agreement.description,
            IdConfiguracionEmpresa: parentId,
            Revision: agreement.revision,
            Calculos: null
          }
          this.model.Convenios.push(convenio);
        }
      }
    })

    if (this.model.Convenios == null || this.model.Convenios == undefined) {
      this.model.Convenios = new Array<ConveniosEmpresa>();
    }
  }

  processNotifications() {
    let parentId = this.model.isNew ? null : this.model.Id.toString();

    if (!this.model.Notificaciones)
      this.model.Notificaciones = new Array<NotificacionesEmpresa>();

    this.model.Notificaciones = this.model.Notificaciones.filter(x => this.selectedUsers.includes(x.IdUsuario));

    this.selectedUsers.forEach(idUsuario => {

      if (this.model.Notificaciones.findIndex(x => x.IdUsuario == idUsuario) == -1) {

        const notificacion: NotificacionesEmpresa = {
          IdUsuario: idUsuario,
          IdConfiguracionEmpresa: parentId,
          TipoNotificacion: ETipoNotificacion.SustitucionesFinalizadas
        }

        this.model.Notificaciones.push(notificacion);
      }
    });

    if (this.model.Notificaciones == null || this.model.Notificaciones == undefined) {
      this.model.Notificaciones = new Array<NotificacionesEmpresa>();
    }
  }

  getUsers() {
    this._usersService.getAllModels().subscribe(users => {
      this.users = users ?? new Array<User>();
    }, error => {
      console.error(error);
    });
  }

  getAgreements(companyCode: number) {

    this.companyService.getAgreements(companyCode.toString()).subscribe((response: A3LCompanyAgreements[]) => {
      if (response) {
        this.agreements = Object.assign(new Array<A3LCompanyAgreements>(), response);
        this.agreements.forEach((element: A3LCompanyAgreements) => {
          const agreement = Object.assign(new A3LCompanyAgreements(), element);
          agreement["id"];
          console.log(agreement["id"]);
        });
      }
    }, error => {
      console.error(error);
    });
  }

  getSelectedAgreements() {
    if (!this.model || !this.model.CodigoEmpresa)
      return;
    this._conveniosEmpresaService.getAllModels(this.model.CodigoEmpresa.toString()).subscribe(convenios => {
      this.companySelectedAgreements = convenios ?? new Array<ConveniosEmpresa>();
    },
      error => {
        console.error(error);
      })
  }

  getProvincias() {
    this.provincias = undefined;
    this._provinciasService.getAll().subscribe((result: Provincia[]) => {
      this.provincias = result;
    }, error => {
      console.error(error);
    })
  }

  companySelectedChanged(company: A3LCompany) {

    if (this.model)
      this.model.CodigoEmpresa = company?.companyCode;

    if (company?.companyCode) {
      //this.getConcepts(company.companyCode);
      this.getAgreements(company.companyCode);
    }
  }

  onSelectedAgreementsChange(event: any) {

    if (!this.companySelectedAgreements)
      return;

    this.companySelectedAgreement = this.companySelectedAgreements.find(x => x.Id == event);
    if (this.companySelectedAgreement)
      this.calculosBolsaVacacionesActivo = true;
    else
      this.calculosBolsaVacacionesActivo = false;

    // Se cargan los datos de las pagas extras que dependen del convenio
    this.calculosConvenios.cargarPagasExtra(this.model?.CodigoEmpresa?.toString(), this.companySelectedAgreement?.Codigo);
  }

  onSubmitAgreementsConfig() {

    if (this.calculosConvenios.dataGrid.instance.hasEditData()) {
      this._messageDialog.ShowAlert(
        'Hay lineas pendientes de guardar',
        'Atención'
      );
      return;
    }

    if (!this.companySelectedAgreement) {
      this._messageDialog.ShowAlert("No se ha seleccionado un convenio", "No actualizado");
      return;
    }

    this.companySelectedAgreement.Calculos.forEach((element: DatosCalculoBolsaVacaciones) => {
      element.IdConvenioEmpresa = this.companySelectedAgreement.Id;

      // Conceptos
      element.ConceptosBolsaVacaciones = [];

      // Concepto empleado
      if (element.SelectedEmployeeConcept) {
        element.ConceptosBolsaVacaciones.push({
          Id: null,
          IdDatosCalculoBolsaVacaciones: null,
          TipoConcepto: EnumConceptType.Employee,
          CodigoConcepto: element.SelectedEmployeeConcept.toString(),
          Prorrateado: element.ConceptoEmpleadoProrrateado || false
        })
      }

      // Concepto variable
      if (element.SelectedVariableConcept) {
        element.ConceptosBolsaVacaciones.push({
          Id: null,
          IdDatosCalculoBolsaVacaciones: null,
          TipoConcepto: EnumConceptType.Variable,
          CodigoConcepto: element.SelectedVariableConcept.toString(),
          Prorrateado: false
        })
      }

      // Concepto paga
      if (element.SelectedPayConcepts && element.SelectedPayConcepts.length > 0) {
        element.SelectedPayConcepts.forEach(spc =>
          element.ConceptosBolsaVacaciones.push({
            Id: null,
            IdDatosCalculoBolsaVacaciones: null,
            TipoConcepto: EnumConceptType.Pay,
            CodigoConcepto: spc.toString(),
            Prorrateado: false
          }));
      }

      // Pagas extra
      element.PagasExtra = [];

      if (element.SelectedPagasExtra) {
        element.SelectedPagasExtra.forEach(spe =>
          element.PagasExtra.push({
            Id: null,
            IdDatosCalculoBolsaVacaciones: null,
            ExtraPayName: spe
          }));
      }
    });

    this._conveniosEmpresaService.update(this.companySelectedAgreement.Id, this.companySelectedAgreement).subscribe(response => {
      this._messageDialog.ShowMessage("Operación realizada correctamente", "Actualizado");
    }, error => {
      console.error(error);
      this._messageDialog.ShowException(error);
    })
  }

  onCalculosConvenioGridUpdated() {
    this.onSubmitAgreementsConfig();
  }

  onClonatedItem(parametro: DatosCalculoBolsaVacaciones) {
    const elementoEncontrado = this.companySelectedAgreements.find(c => c.Id === parametro.IdConvenioEmpresa);
    elementoEncontrado.Calculos.push(parametro);
  }

}
function areEqual(elemento: ConveniosEmpresa, companySelectedAgreementValueClone: ConveniosEmpresa): unknown {
  throw new Error('Function not implemented.');
}

